import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from 'components/Icon';

import Style from '../SocialLogin.module.scss';

const TEST_ID = 'shared-social-facebook';
const SocialFacebook = ({
  facebookGenericError,
  facebookLoginOptionalText,
  facebookLoginText,
  facebookSignupOptionalText,
  facebookSignupText,
  onSocialFacebookLogin,
  showFacebookLogin,
  showFacebookSignup,
  isConsolidatedSignUp,
}) => {
  const showFacebook = showFacebookLogin || showFacebookSignup;

  if (!showFacebook) return null;

  let text = facebookLoginText;
  let optionalText = facebookLoginOptionalText;
  const onClick = onSocialFacebookLogin;

  if (showFacebookSignup) {
    text = facebookSignupText;
    optionalText = facebookSignupOptionalText;
  }

  return (
    <div data-test={TEST_ID}>
      <button
        className={classNames(
          Style.socialFacebookButton,
          isConsolidatedSignUp ? Style.circleIcon : null,
        )}
        onClick={onClick}
      >
        <span className={Style.socialFacebookButtonIcon}>
          <Icon icon="facebook" color={!isConsolidatedSignUp ? 'white' : ''} size="full" />
        </span>
        {!isConsolidatedSignUp && (
          <div>
            <span className={Style.socialFacebookButtonText}>{text}</span>
            <span className={Style.socialFacebookButtonTextOptional}>{optionalText}</span>
          </div>
        )}
      </button>
      {!isConsolidatedSignUp && (
        <div className={Style.defaultErrorGenericText}>{facebookGenericError}</div>
      )}
    </div>
  );
};

SocialFacebook.defaultProps = {
  facebookGenericError: null,
  facebookLoginOptionalText: null,
  facebookLoginText: null,
  facebookSignupOptionalText: null,
  facebookSignupText: null,
  onSocialFacebookLogin: () => {},
  showFacebookLogin: null,
  showFacebookSignup: null,
};

SocialFacebook.propTypes = {
  isConsolidatedSignUp: PropTypes.bool,
  facebookGenericError: PropTypes.string,
  facebookLoginOptionalText: PropTypes.string,
  facebookLoginText: PropTypes.string,
  facebookSignupOptionalText: PropTypes.string,
  facebookSignupText: PropTypes.string,
  onSocialFacebookLogin: PropTypes.func,
  showFacebookLogin: PropTypes.bool,
  showFacebookSignup: PropTypes.bool,
};

export default SocialFacebook;
